module.exports = __webpack_public_path__ + "static/start-illiustration-9ec72477dd20725383aeadbaa21c2fdd.jpg";